export function calculateClientAge(
  intakeSurveyAge: number | null | undefined,
  policyYear: number,
): number | null {
  if (intakeSurveyAge == null) return null;
  // intakeSurveyAge is the client's age at projection start (policy year 1)
  // Each subsequent policy year adds 1 year
  return intakeSurveyAge + (policyYear - 1);
}
